<template>
    <div class="applied">
        <div class="listings">
             <div class="loading-box" v-show="loading">
                <LoadingIndicator message="Getting Applied Jobs"/>
            </div>
              <div class="loading-box" v-show="!loading && error">
                    <SystemMessage :message=" errorMessage != '' ? errorMessage : pagecontent.myJobs.appliedJobsSystemMessage"/>
            </div>
            <SystemMessage v-if="loading == false && jobs.length == 0 && !error" message="No Applied Jobs available. Try to refresh the page"/>
            <JobListings v-else ref="jobListings"
                    :title="title"
                    :total="total"
                    :jobs="jobs"
                    :init-loading="loading"
                    :init-loading-error="error"
                    :get-page-async="getAppliedJobsPageAsync"/>
        </div>
    </div>
</template>
<script>
import pagecontent from '@/assets/text.json'
import JobListings from '@/components/Jobs/JobListings.vue';
import LoadingIndicator from '@/components/Utility/LoadingIndicator.vue';
import SystemMessage from '@/components/Utility/SystemMessage.vue';
import { getAppliedJobsAsync } from '@/services/public/vacancyService';
export default {
    components:{
        JobListings,
        SystemMessage,
        LoadingIndicator
    },
    data(){
        return{
        title: "Applied Jobs",
        pagecontent,
        jobs: [],
        total:0,
        loading: true,
        error:false,
        pageNumber:0,
        errorMessage: ""
        }
    },
    methods:{
                //when paginating use these methods
            updateCollection(items) { 
            // call child method
            this.$refs.jobListings.updateCollection(items);
            },
            clearCollection() {
            this.$refs.jobListings.clearCollection();
            },
            async getJobListings(){
            let data = await getJobListingsAsync(1);
                if(data.success == true){
                this.jobs = data.listings;
                
                }
            },
            async getAppliedJobsPageAsync(){ //is run from inside JobListings
                this.pageNumber+=1;
                if(this.pageNumber == 1){
                this.startLoading(); 
                }else{
                this.$refs.jobListings.setButtonToLoadingMore();
                }
                try{
                let data = await getAppliedJobsAsync(this.pageNumber);
                this.stopLoading();
                if(data.success == true){
                    //check if the first page is empty []
                    if(this.pageNumber == 1 && data.listings.length == 0){
                        let err = new Error();
                        err.message = "You haven't applied to any jobs yet.";
                        throw err;
                    }else{
                        //normal feed
                        this.jobs = data.listings;
                        this.total = data.listings[0].count;
                        this.$refs.jobListings.setButtonToSuccessfulLoad();
                    }  
                }else{
                
                    if(this.pageNumber == 1){
                    this.pageNumber-=1;
                    this.error = true;
                    }else{
                    this.pageNumber-=1;
                    this.$refs.jobListings.setButtonToLoadingError();
                    }
                }
                }catch(e){    
                this.stopLoading();
                if(this.pageNumber == 1){
                    this.pageNumber-=1; //keep this
                    this.error = true;
                    //show empty first page [] error (or any error that might arise)
                    this.errorMessage = e.message;
                }else{
                    this.pageNumber-=1; //keep this
                    this.$refs.jobListings.setButtonToLoadingError();
                }
                }

                
            
                
            },
            startLoading(){
            this.loading = true;
            this.error = false;
            this.errorMessage = "";
            },
            stopLoading(){
            this.loading = false;
            }
    }
}
</script>
<style scoped>
     .loading-box{
    margin-top:2rem;
  }
</style>